<template lang="pug">
  .dashboard-view
    v-container.pa-0(style="max-width:600px")

      v-row.mb-0(no-gutters)
        v-col(cols="12" v-if="member.role === 'Admin'")
          sales-chart(:company="company" :stickyFilter="true" @spanChange="handleChangeSpan" :isAnalytics="true")

        v-col.mt-6(cols="12")
          .h6.ma-2.mb-3 {{ $t('sales_funnel') }}
          dashboard-funnel(:company="company" :metrics="metrics")

        v-col.mt-6(v-if="Auth('component', '/admin/analytics#product_ranking')" cols="12")
          .h6.ma-2.mb-3 {{ $t('product_ranking') }}
          ProductsRanking(:company="company" :span.sync="selectedSpan" :dateRange="customDateFilterRange")

        v-col.mt-6(v-if="Auth('component', '/admin/analytics#sales_team_ranking')" cols="12")
          .h6.ma-2.mb-3 {{ $t('sales_team_ranking') }}
          MembersRanking(:company="company" :span.sync="selectedSpan" :dateRange="customDateFilterRange")

        v-col.mt-10(cols="12")
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SalesChart from '@/components/analytics/SalesChart.vue'
import DashboardFunnel from '@/components/dashboard/DashboardFunnel.vue'
import ProductsRanking from './analytics/ProductsRanking.vue'
import MembersRanking from './analytics/MembersRanking.vue'

export default {
  name: 'Analytics',
  components: {
    SalesChart, DashboardFunnel, ProductsRanking, MembersRanking
  },
  props: ['company', 'menu'],
  data: () => ({
    metrics: null,
    customDateFilterRange: [],
    selectedSpan: 'week',
  }),
  computed: {
    ...mapState('user', ['member'])
  },
  watch: {
    company (val) {
      if (val) {
        this.fetchMetrics('week')
      }
    }
  },
  mounted () {
    this.fetchMetrics('week')
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleChangeSpan (data) {
      this.selectedSpan = data.range.id
      this.customDateFilterRange = data.selectedDateRange
      this.fetchMetrics(data.range.id, data.selectedDateRange)
    },
    formatDateRange (range) {
      if (range.length === 0) {
        return 'Date Range'
      } else if (range.length === 1) {
        const [year, month, day] = range[0].split('-')
        return `${day}/${month}/${year} -`
      } else {
        const [year1, month1, day1] = range[0].split('-')
        const [year2, month2, day2] = range[1].split('-')
        return `${day1}/${month1}/${year1} - ${day2}/${month2}/${year2}`
      }
    },
    runCustomDateFilter () {
      this.customDateFilterMenu = false
      this.fetchMetrics('custom', this.customDateFilterRange)
    },
    fetchMetrics (span, range=null) {
      let url = `/companies/${this.company.id}/metrics/?span=${span}`
      if (span === 'custom') {
        url = `/companies/${this.company.id}/metrics/?span=custom&from=${range[0]}&until=${range[1]}`
      }
      this.$axios.get(url)
        .then(resp => {
          this.metrics = resp.data
        })
        .catch(e => {
          this.showMessage(['error', e.response.data[0]])
          if (range) {
            this.customDateFilterRange.pop()
            this.customDateFilterMenu = true
          }
        })
    }
  }
}
</script>

<style>
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
  div.v-picker__title {
    height: 0;
    padding: 0;
  }
</style>

<i18n>
{
  "en": {
    "sales_funnel": "Sales Funnel",
    "product_ranking": "Product Ranking",
    "sales_team_ranking": "Sales Team Ranking"
  },
  "id": {
    "sales_funnel": "Funnel Penjualan",
    "product_ranking": "Peringkat Produk",
    "sales_team_ranking": "Peringkat Tim Penjualan"
  }
}
</i18n>